export * from '@primeuix/themes/aura/skeleton';
export { default } from '@primeuix/themes/aura/skeleton';
